import { Component } from '@angular/core';
import { BaseFieldComponent } from '../base-field.component';
@Component({
  selector: 'ngx-dynamic-form-group',
  templateUrl: './dynamic-form-group.component.html',
  styleUrls: ['./dynamic-form-group.component.scss'],
})
export class DynamicFormGroupComponent extends BaseFieldComponent  {

}
